import $ from "jquery";
import { vuwer } from "@@assets/scripts/common";

vuwer.get("pageHeader").add("slider", {
	vuwType: "slider",
	
	selector() {
		return this.container.$self && this.container.$self.children(
			".slider"
		);
	},
	slickOptions: {
		dots: false,
		infinite: true
	},
	
	onReadyLast($self) {
		if(!$self || !this.isSlides) {
			return false;
		}
		
		const $nav = $self.next(".slider-nav");
		!!$nav.length && $nav.children().each((i, elm) => {
			$(elm).addClass("hover-target").on("click", e => $self.slick("slickGoTo", i));
		});
	}
});
